export type TSsoProvidersListParams = {
  page: number;
  pageSize: number;
  orderBy: string;
  orderType: 'asc' | 'desc';
  search: string;
};

export const ssoProvidersKeys = {
  all: [{ module: 'ssoProviders' }] as const,
  lists: () => [{ ...ssoProvidersKeys.all[0], scope: 'list' }] as const,
  list: (params: TSsoProvidersListParams) => [{ ...ssoProvidersKeys.lists()[0], params }] as const,
};
